import { withIcon } from './withIcon';

const TrashAlternativeSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0268 8.75019C11.4336 8.34336 12.0931 8.34336 12.4999 8.75019C12.9068 9.15703 12.9068 9.81653 12.4999 10.2234L11.4731 11.2502L12.4999 12.277C12.9068 12.6839 12.9068 13.3434 12.4999 13.7502C12.0931 14.157 11.4336 14.157 11.0268 13.7502L9.99993 12.7234L8.97309 13.7502C8.56626 14.157 7.90672 14.157 7.49992 13.7502C7.09313 13.3434 7.09313 12.6839 7.49992 12.277L8.52676 11.2502L7.49992 10.2234C7.09313 9.81653 7.09313 9.15703 7.49992 8.75019C7.90672 8.34336 8.56626 8.34336 8.97309 8.75019L9.99993 9.77703L11.0268 8.75019Z"
      fill="var(--v3-black-100)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0835 0.416748C6.16302 0.416748 5.41683 1.16294 5.41683 2.08341V4.16675H1.87516C1.29986 4.16675 0.833496 4.63311 0.833496 5.20842C0.833496 5.78371 1.29986 6.25008 1.87516 6.25008H3.03938L3.65788 16.7646C3.7097 17.6456 4.43921 18.3334 5.32167 18.3334H14.6787C15.5611 18.3334 16.2907 17.6456 16.3424 16.7646L16.9609 6.25008H18.1252C18.7005 6.25008 19.1668 5.78371 19.1668 5.20842C19.1668 4.63311 18.7005 4.16675 18.1252 4.16675H14.5835V2.08341C14.5835 1.16294 13.8373 0.416748 12.9168 0.416748H7.0835ZM12.5002 4.16675V2.50008H7.50016V4.16675H12.5002ZM14.874 6.25008H5.12631L5.71455 16.2501H14.2857L14.874 6.25008Z"
      fill="var(--v3-black-100)"
    />
  </svg>
);

export const TrashAlternative = withIcon(TrashAlternativeSvg);
